module.exports = __webpack_public_path__ + "img/battleJet.872ed039.png";